import React from 'react';
import { Shield, Settings, Sparkles, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { services } from '../data/mock';

export const Services = () => {
  const iconMap = {
    Shield: Shield,
    Settings: Settings,
    Sparkles: Sparkles
  };

  return (
    <section id="services" className="py-24 bg-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold">
            Our Services
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
            Comprehensive Manpower Solutions
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Three specialized divisions working together to provide complete workforce solutions
            tailored to your organizational needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-slate-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-slate-200 hover:border-blue-300"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.division}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${service.color} opacity-60`} />
                  
                  {/* Icon Badge */}
                  <div className="absolute top-6 left-6 w-16 h-16 rounded-xl bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-lg">
                    <Icon className="w-8 h-8 text-blue-600" />
                  </div>

                  {/* Short Name Badge */}
                  <div className="absolute top-6 right-6 px-4 py-2 bg-white/90 backdrop-blur-sm rounded-full">
                    <span className="text-sm font-bold text-slate-900">{service.shortName}</span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-8 space-y-4">
                  <h3 className="text-2xl font-bold text-slate-900 group-hover:text-blue-600 transition-colors">
                    {service.division}
                  </h3>
                  
                  <p className="text-slate-600 leading-relaxed">
                    {service.description}
                  </p>

                  {/* Offerings List */}
                  <div className="pt-4 space-y-2">
                    {service.offerings.map((offering, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full bg-blue-600" />
                        <span className="text-sm text-slate-700">{offering}</span>
                      </div>
                    ))}
                  </div>

                  {/* Learn More Button */}
                  <Button
                    variant="ghost"
                    className="w-full mt-6 group-hover:bg-blue-50 group-hover:text-blue-700 transition-colors"
                  >
                    Learn More
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-slate-700 mb-6">
            Need a customized manpower solution for your organization?
          </p>
          <Button
            size="lg"
            onClick={() => document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all"
          >
            Request Custom Solution
          </Button>
        </div>
      </div>
    </section>
  );
};
